import { useEffect, useState } from 'react';
import { useClientStore, useFrameStore, useRouterStore } from 'apps/hooks';
import { AvatarProps } from 'components/Avatar/Avatar';
import {
  communityRoutes,
  conditionalProjectRoutes,
} from 'apps/components/Frame/config';

import { analytics } from 'core/analytics';

export type ActiveInfoProps = {
  avatarSize?: AvatarProps['size'];
};

// TODO: This should not exist like this and should be removed/refactored
// However it's now mostly harmless.
// I think the couple of places where it's used can be replaced
// with something simpler
export const useCrumbItemsLoading = () => {
  const routerStore = useRouterStore();
  const frameStore = useFrameStore();
  const clientStore = useClientStore();

  const { route } = routerStore;

  const {
    currentSpaceData: activeSpaceCheckRawInfo,
    workspaces,
    teamsQueryStatus,
  } = clientStore;
  const spaceLoading =
    teamsQueryStatus === 'init' || teamsQueryStatus === 'loading';

  const [lastSlug, setLastSlug] = useState(null);
  const [currentSpaceData, setCurrentSpaceData] = useState(
    activeSpaceCheckRawInfo,
  );

  useEffect(() => {
    if (clientStore.slugFromRouteOrSpace !== lastSlug || !currentSpaceData) {
      setCurrentSpaceData(activeSpaceCheckRawInfo);
      setLastSlug(clientStore.slugFromRouteOrSpace);
    }
  }, [lastSlug, activeSpaceCheckRawInfo, clientStore.slugFromRouteOrSpace]);

  useEffect(() => {
    if (lastSlug) {
      analytics.linkAmplitudeGroup(lastSlug);
    }
  }, [lastSlug]);

  const { file, project } = frameStore;

  const { sharedFileId, rfqId, slug: projectSlug } = route.params;

  const crumbItemsLoading =
    !currentSpaceData ||
    !clientStore.slugFromRouteOrSpace ||
    spaceLoading ||
    !workspaces?.length ||
    (sharedFileId && !file) ||
    (projectSlug && !project && !communityRoutes.includes(route.name)) ||
    (rfqId && !file) ||
    (conditionalProjectRoutes.includes(route.name) && projectSlug && !project);

  return {
    crumbItemsLoading,
  };
};
